import axios from "axios";
import { t } from "i18next";
import _ from "lodash";

import AlertsService from "services/alerts-service";

import { mergeStorage, omitStorage, putStorage } from "hooks/useStorage";

const EventsApi = {
    getEvents: async () => {
        try {
            const { data: response } = (await axios.get(`/events/all`)) as any;
            mergeStorage(`events`, _.keyBy(response, `id`));
            return response;
        } catch (error) {
            throw AlertsService.showError(t("326jgmw6xtq"));
        }
    },
    getMyUniversityEvents: async () => {
        try {
            const { data: response } = (await axios.get(`/events/my`)) as any;
            mergeStorage(`events`, _.keyBy(response, `id`));
            return response;
        } catch (error) {
            throw AlertsService.showError(t("3hcmgp61zj6"));
        }
    },
    createEvent: async (details: any) => {
        try {
            const { data: response } = (await axios.post(`/events`, { details })) as any;
            await EventsApi.getMyUniversityEvents();
            return response;
        } catch (error) {
            throw AlertsService.showError(t("1mmt40icwz8"));
        }
    },
    updateEvent: async (event: { id: string; universityId: string; [key: string]: any }) => {
        try {
            const { data: response } = (await axios.put(`/events`, event)) as any;
            await EventsApi.getMyUniversityEvents();
            putStorage(`events.${event.id}`, response);
            AlertsService.showSuccess(`Событие успешно обновлено`);
            return response;
        } catch (error) {
            throw AlertsService.showError(t("qckfa1pqmw"));
        }
    },
    deleteEvent: async (eventId: string) => {
        try {
            await axios.delete(`/events/${eventId}`);
            omitStorage(`events.${eventId}`);
            AlertsService.showSuccess(`Событие успешно удалено`);
            return;
        } catch (error) {
            throw AlertsService.showError(t("8rjqyh8bkzf"));
        }
    },
    getMyBookings: async () => {
        try {
            const { data: response } = (await axios.get(`/event-bookings/my`)) as any;
            mergeStorage(`events-requests`, _.keyBy(response, `id`));
            return response;
        } catch (error) {
            throw AlertsService.showError(t("aqo8kgzqopg"));
        }
    },
    getAllBookings: async () => {
        try {
            const { data: response } = (await axios.get(`/event-bookings/all`)) as any;
            mergeStorage(`events-requests`, _.keyBy(response, `id`));
            return response;
        } catch (error) {
            throw AlertsService.showError(t("rnh6gk3bnln"));
        }
    },
    getBookings: async (universityId: string) => {
        try {
            const { data: response } = (await axios.get(`/universities/${universityId}/event-bookings`)) as any;
            mergeStorage(`events-requests`, _.keyBy(response, `id`));
            return response;
        } catch (error) {
            throw AlertsService.showError(t("xqfvnw1c0t"));
        }
    },
    createBooking: async (booking: { eventId: string; details: Object }) => {
        try {
            const { data: response } = (await axios.post(`/event-bookings`, booking)) as any;
            AlertsService.showSuccess(`Бронирование успешно создано`);
            return response;
        } catch (error) {
            throw AlertsService.showError(t("nbgxl7eqlx"));
        }
    },
    updateBooking: async (booking: { id: string; universityId: string; details: Object }) => {
        try {
            const { data: response } = (await axios.put(`/event-bookings`, booking)) as any;
            await EventsApi.getBookings(booking.universityId);
            AlertsService.showSuccess(`Бронирование успешно обновлено`);
            return response;
        } catch (error) {
            throw AlertsService.showError(t("uanacos22ip"));
        }
    },
    deleteBooking: async (bookingId: string) => {
        try {
            await axios.delete(`/event-bookings/${bookingId}`);
            omitStorage(`events-requests.${bookingId}`);
            AlertsService.showSuccess(`Бронирование успешно удалено`);
            return;
        } catch (error) {
            throw AlertsService.showError(t("og7qeqqmidk"));
        }
    },
};

export default EventsApi;
